

export default function EtekafRequestList({etecafId}) {
    return (
        <>
            <p>Etekaf RequestList</p>
        </>
    )
}